import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "5",
  height: "10",
  viewBox: "0 0 5 10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.5 9L1 5L3.5 1",
      stroke: "#4D4D4D",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }